module.exports = __webpack_public_path__ + "static/media/2_8.5a854bd3.png";